import { render, staticRenderFns } from "./Breakout.vue?vue&type=template&id=050995fb"
import script from "./Breakout.vue?vue&type=script&lang=js"
export * from "./Breakout.vue?vue&type=script&lang=js"
import style0 from "./Breakout.vue?vue&type=style&index=0&id=050995fb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports